export const DocumentType = {
  CPF: 1,
  RG: 2,
  CRACHA: 3,
  CRACHA_ACOMPANHANTE: 4,
  CNH: 5,
  PASSPORT: 6,
  DRT: 7,
};
